import { Form, FormSection } from "components/ResumeForm/Form";
import { Input } from "components/ResumeForm/Form/InputGroup";
import RichEditor from "./Form/QuillEditor";
import type { CreateHandleChangeArgsWithDescriptions } from "components/ResumeForm/types";
import { useAppDispatch, useAppSelector } from "lib/redux/hooks";
import {
  changeWorkExperiences,
  selectWorkExperiences,
} from "lib/redux/resumeSlice";
import type { ResumeWorkExperience } from "lib/redux/types";
import { useState } from "react";
import RichEditorWithSuggestions from "./Form/RichEditorWithSuggestions";

export const WorkExperiencesForm = () => {
  const workExperiences = useAppSelector(selectWorkExperiences);
  const dispatch = useAppDispatch();
  const [checkedState, setCheckedState] = useState<boolean[]>(
    Array(workExperiences.length).fill(false)
  );

  const showDelete = workExperiences.length > 1;

  return (
    <Form form="workExperiences" addButtonText="Add Job">
      {workExperiences.map((item, idx) => {
        const { company, jobTitle, startDate, endDate, descriptions } = item;
        const handleWorkExperienceChange = (
            ...[
              field,
              value,
            ]: CreateHandleChangeArgsWithDescriptions<ResumeWorkExperience>
          ) => {
            // TS doesn't support passing union type to single call signature
            // https://github.com/microsoft/TypeScript/issues/54027
            // any is used here as a workaround
            dispatch(changeWorkExperiences({ idx, field, value } as any));
          };

          const handleCheckboxChange = (idx: number) => {
            // Toggle the checked state
            const updatedCheckedState = [...checkedState];
            const isChecked = !updatedCheckedState[idx];
            updatedCheckedState[idx] = isChecked;

            setCheckedState(updatedCheckedState);

            // Set the endDate based on the checkbox state
            const endDateValue = isChecked ? "Present" : ""; // Set to empty string when unchecked or restore a value if you have one

            // Dispatch the endDate change to Redux
            dispatch(
              changeWorkExperiences({
                idx,
                field: "endDate",
                value: endDateValue,
              })
            );
          };

          const showMoveUp = idx !== 0;
          const showMoveDown = idx !== workExperiences.length - 1;

          return (
            <FormSection
              key={item.id ?? idx}
              form="workExperiences"
              idx={idx}
              showMoveUp={showMoveUp}
              showMoveDown={showMoveDown}
              showDelete={showDelete}
              deleteButtonTooltipText="Delete job"
            >
              <Input
                label="Company"
                labelClassName="col-span-full"
                name="company"
                placeholder="Tech Dreamers Inc."
                value={company}
                onChange={handleWorkExperienceChange}
              />
              <Input
                label="Job Title"
                labelClassName="col-span-full "
                name="jobTitle"
                placeholder="Code Alchemist"
                value={jobTitle}
                onChange={handleWorkExperienceChange}
              />
              <Input
                label="Start Date"
                labelClassName="col-span-3"
                name="startDate"
                placeholder="Jun 2022 - Present"
                value={startDate}
                onChange={handleWorkExperienceChange}
              />
              <Input
                label="End Date"
                labelClassName="col-span-3"
                name="endDate"
                placeholder="Jun 2022 - Present"
                value={endDate}
                onChange={handleWorkExperienceChange}
                disabled={checkedState[idx]}
              />
              <div className="col-span-3">
                <label className="flex cursor-pointer items-center space-x-2">
                  <span className="font-medium text-gray-700 lg:text-xs xl:text-base">
                    Currently Working Here
                  </span>
                  <input
                    type="checkbox"
                    checked={checkedState[idx]}
                    onChange={() => handleCheckboxChange(idx)}
                    className="scale-125 cursor-pointer"
                  />
                </label>
              </div>
              {/* <RichEditor
                name="descriptions"
                value={descriptions}
                onChange={handleWorkExperienceChange}
                labelClassName="col-span-full"
                placeholder="Work Description"
              /> */}
              <RichEditorWithSuggestions
                name="descriptions"
                value={descriptions}
                onChange={handleWorkExperienceChange}
                placeholder="Work Description"
                section="workExperiences"
              />
            </FormSection>
          );
        }
      )}
    </Form>
  );
};
